import * as types from './mutation-types';
import * as actions from './actions';

const state = {
  selectedPlatformContainer: {}
};

const getters = {
  selectedPlatformContainer: state => state.selectedPlatformContainer,
}

const mutations = {
  [types.UPDATE_SELECTED_CONTAINER](state, selectedPlatformContainer){
    state.selectedPlatformContainer = selectedPlatformContainer;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
